import { CMSResource } from "app/resources/cmsresource";
import { FooterCellTypeResource } from "app/models/FooterCellTypeResource";
export class FooterCellTypeListResource extends CMSResource {

    footerCellTypeListResource: FooterCellTypeResource[];

}
